import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ActionComponent from '../../../components/ActionComponent'
import i18n from 'simple-react-i18n'
import HomeAction from '../../../home/actions/HomeAction'
import DtoPiezometerLight from '../../dto/DtoPiezometerLight'
import Select from '../../../components/forms/Select'
import Card from '../../../components/card/Card'
import ExportAction from '../../../export/actions/ExportAction'
import ToastrAction from 'toastr/actions/ToastrAction'
import WaitAction from 'wait/WaitAction'
import { getDateExport, getFullDate, shortenHumanize } from '../../../utils/DateUtil'
import PiezometryAction from '../../actions/PiezometryAction'
import DtoPiezometerChartLandmarks from '../../dto/situation/DtoPiezometerChartLandmarks'
import { getHardPiezoDataTypes } from '../../../utils/PiezometryUtils'
import {
    CSV_EXPORT,
    EXCEL_EXPORT,
    EXPORT_JOB_STATUS,
    EXPORT_STATIONS_MEASURES,
    EXPORT_STATIONS_MODELS,
    EXPORT_TYPE_OPTIONS,
    MODEL_EXPORT,
} from '../../../export/constants/ExportConstants'
import StationsModelExportPanel from '../../../station/components/StationsModelExportPanel'
import StationsExcelExportPanel from '../../../station/components/StationsExcelExportPanel'
import { arrayOf } from '../../../utils/StoreUtils'
import DtoParametrageDataType from '../../dto/DtoParametrageDataType'
import Table from '../../../components/datatable/Table'
import StationAction from '../../../station/actions/StationAction'
import DtoExportJob from '../../../station/dto/DtoExportJob'
import { intersectionWith, isUndefined, keyBy, orderBy, pick, uniqBy } from 'lodash'
import { getLogin } from '../../../utils/SettingUtils'
import { getCurrentLang } from '../../../utils/LangUtils'
import { nbPerPageLabelTiny } from '../../../referencial/constants/ReferencialConstants'
import { getDuration, getLoadingBar, getStatusIcon, getStatusLabel } from '../../../utils/ExportJobUtils'
import moment from 'moment'
import { nFormatter } from '../../../utils/NumberUtil'
import { componentHasHabilitations } from '../../../utils/HabilitationUtil'
import { H_PIEZO_EXPORT } from '../../../account/constants/AccessRulesConstants'
import { push } from '@lagunovsky/redux-react-router'
import SelectionTableModal from 'components/modal/SelectionTableModal'
import { PiezometerFilterField } from 'components/datatable/SimpleSelectionTable'
import { searchAllCharacters } from 'utils/StringUtil'
import CityAction from 'referencial/components/city/actions/CityAction'
import CityDto from 'referencial/components/city/dto/CityDto'
import Checkbox from '../../../components/forms/Checkbox'
import Input from '../../../components/forms/Input'
import { setConfirmationModal } from '../../../utils/FormUtils'
import { STATION_TYPE_NAME } from '../../../station/constants/StationConstants'
import JobAction from '../../../import/actions/JobAction'
import DtojobTable from '../../../import/dto/DtoJobTable'
import { Grid2 } from '@mui/material'


class PiezometersExportApp extends ActionComponent {
    isCheckingProgress = false

    state = {
        exportType: undefined,
        model: 0,
        modelStartDate: null,
        modelEndDate: null,
        displayCote: 2,
        tmpFilter: {
            startDate: undefined,
            endDate: undefined,
            group: 'BRUTE',
            withStatusQualificationCodes: false,
            exportDir: 'EXPORT/tmp',
        },
        selectStationIsOpen: false,
        selectedStations: [],
        dataType: 0,
        jobs: [],
        jobId: -20,
        noZip: false,
    }

    setTitle = () => {
        this.props.setTitle([{
            title: i18n.piezometry,
            href: 'piezometry',
        }, {
            title: i18n.export,
            href: 'piezometry',
        }])
    }

    recursiveFetchExportJob = () => {
        if (!this.isCheckingProgress) {
            return
        }
        this.props.fetchExportJobsTmp('piezometry').then(response => {
            if (response.some(e => e.status === EXPORT_JOB_STATUS.WAITING || e.status === EXPORT_JOB_STATUS.IN_PROGRESS)) {
                setTimeout(() => this.recursiveFetchExportJob(), 5000)
            } else {
                this.isCheckingProgress = false
            }
        })
    }

    regularProgressUpdate = () => {
        this.isCheckingProgress = true
        this.recursiveFetchExportJob()
    }

    componentDidMount() {
        if (!componentHasHabilitations(H_PIEZO_EXPORT)) { // A modifier quand react-router sera à jour
            this.props.push('/unauthorized')
            return
        }
        this.setTitle()
        this.props.fetchEnvironmentModelsByType('piezometry')
        if (!this.props.piezometers.length) {
            this.props.fetchPiezometersLight()
        }
        if (!this.props.cities.length) {
            this.props.fetchCities()
        }
        this.props.fetchPiezometryDataTypes()
        this.regularProgressUpdate()
        JobAction.promiseJobTable({ jobType: 'exportTmpScheduled', displayMode: 'job' })
            .then(jobs => this.setState({ jobs: (jobs?.data ?? []).map(j => new DtojobTable(j)) }))
    }

    componentWillUnmount() {
        this.isCheckingProgress = false
    }

    onChangeFilter = (value) => {
        this.setState(({ tmpFilter }) => ({ tmpFilter: { ...tmpFilter, ...value } }))
    }

    onChange = (value) => {
        this.setState(value)
    }

    onCloseModal = () => {
        this.setState({ selectStationIsOpen: false })
    }

    onApplyExport = (type) => {
        const { tmpFilter, dataType, selectedStations, jobId, noZip } = this.state
        const { waitStart, waitStop } = this.props
        waitStart()
        const availableDataTypes = uniqBy([ ...getHardPiezoDataTypes(), ...this.props.piezometryDataTypes], 'id')
        const selectedDataTypes = availableDataTypes.filter(d => !dataType || d.id === dataType)
        const exportData = {
            exportData: selectedStations.map(id => {
                const piezo = this.props.piezometers.find(p => p.id === id)
                return {
                    station: pick({ ...piezo, stationType: piezo.typeName }, ['id', 'code', 'name', 'stationType']),
                    exportType: type,
                    filename: `${piezo.code}_${getDateExport()}`,
                }
            }),
            startDate: tmpFilter.startDate,
            endDate: tmpFilter.endDate,
            dataTypes: selectedDataTypes.map(({ id, label }) => ({ id, name: label })),
            displayCote: this.state.displayCote,
            withStatusQualificationCodes: tmpFilter.withStatusQualificationCodes,
            group: tmpFilter.group,
            exportDir: tmpFilter.exportDir,
            noZip,
        }
        if (exportData.exportData.length === 0) {
            this.props.toastrWarning(i18n.noDataOverSelectedStationsAndPeriod)
            waitStop()
            return
        }
        if (this.state.scheduledOnJob && !this.state.name) {
            this.props.toastrWarning('Veuillez choisir un nom pour l\'export programmé.')
            waitStop()
            return
        }
        const exportTmpObj = {
            id: 0,
            exportType: EXPORT_STATIONS_MEASURES,
            jobId,
            login: getLogin(),
            creationDate: 0,
            status: EXPORT_JOB_STATUS.WAITING,
            stationType: 'piezometry',
            params: JSON.stringify(exportData),
            scheduledOnJob: this.state.scheduledOnJob,
            name: this.state.name,
        }
        this.props.runExportTmp(exportTmpObj).then(() => {
            if (!this.isCheckingProgress) {
                this.regularProgressUpdate()
            }
        })
        waitStop()
    }
    onApplyExportModel = (modelFileName) => {
        const { selectedStations, tmpFilter, jobId, noZip } = this.state
        const { waitStart, waitStop } = this.props
        const fileNameSplit = modelFileName.split('.')
        const type = fileNameSplit[fileNameSplit.length - 1]
        waitStart()
        const exportData = {
            exportData: selectedStations.map(id => {
                const piezo = this.props.piezometers.find(p => p.id === id)
                return {
                    station: pick({ ...piezo, stationType: piezo.typeName }, ['id', 'code', 'name', 'stationType']),
                    exportType: type,
                    filename: `${piezo.code}_${getDateExport()}`,
                }
            }),
            model: modelFileName,
            startDate: this.state.modelStartDate,
            endDate: this.state.modelEndDate,
            displayCote: this.state.displayCote,
            exportDir: tmpFilter.exportDir,
            noZip,
        }

        if (exportData.exportData.length === 0) {
            this.props.toastrWarning(i18n.noDataOverSelectedStationsAndModel)
            waitStop()
            return
        }
        const exportTmpObj = {
            id: 0,
            exportType: EXPORT_STATIONS_MODELS,
            jobId,
            login: getLogin(),
            creationDate: 0,
            status: EXPORT_JOB_STATUS.WAITING,
            stationType: 'piezometry',
            params: JSON.stringify(exportData),
        }
        this.props.runExportTmp(exportTmpObj).then(() => {
            if (!this.isCheckingProgress) {
                this.regularProgressUpdate()
            }
        })
        waitStop()
    }
    getExportPanel = () => {
        const { exportType, tmpFilter, selectedStations, model, modelStartDate, modelEndDate, displayCote } = this.state
        const { typeEnvironmentModels } = this.props
        const modelTypesOptions = typeEnvironmentModels.filter(t => !t.includes('.xls') || !t.includes('.doc')).map((t, i) => ({ value: i, name: t }))
        if (exportType === MODEL_EXPORT) {
            return (
                <StationsModelExportPanel
                    onApplyExportModel = {this.onApplyExportModel}
                    selectedStations={selectedStations}
                    model={model}
                    modelTypesOptions={modelTypesOptions}
                    onChangeFilter={this.onChangeFilter}
                    onChange={this.onChange}
                    tmpFilter={tmpFilter}
                    startDate={modelStartDate}
                    endDate={modelEndDate}
                    displayCote={displayCote}
                    stationType='piezometry'
                />
            )
        } else if ([CSV_EXPORT, EXCEL_EXPORT].includes(exportType)) {
            return (
                <StationsExcelExportPanel
                    onChangeFilter={this.onChangeFilter}
                    onChange={this.onChange}
                    onApplyExport={() => this.onApplyExport(exportType === EXCEL_EXPORT ? 'xlsx' : 'csv')}
                    selectedStations={selectedStations}
                    tmpFilter={tmpFilter}
                    displayCote={displayCote}
                    dataTypes={uniqBy([...getHardPiezoDataTypes(), ...this.props.piezometryDataTypes], 'id')}
                    selectedDataType={this.state.dataType}
                    stationType={STATION_TYPE_NAME.piezometry}
                />
            )
        }
        return null
    }

    render() {
        const toData = (exports) => orderBy(exports.map(e => ({
            ...e,
            exportTmp: e,
            name: { value: e.name },
            status: { color: 'white', value: getStatusIcon(e.status, 50), setTooltip: () => (<div className='row no-margin valign-wrapper'>{getStatusIcon(e.status, 20)}<div className='padding-left-1'/>{getStatusLabel(e.status)}</div>) },
            type: { value: e.fileType },
            creationDate: { value: getFullDate(e.creationDate), format: 'dd/MM/yyyy HH:mm:ss', cellType: 'date' },
            updateDate: { value: getFullDate(e.updateDate), format: 'dd/MM/yyyy HH:mm:ss', cellType: 'date' },
            author: { value: e.login },
            exportName: { value: i18n[e.exportType] },
            fileLabel: { value: e.filePath === 'NOFILE' ? '' : e.filePath },
            progression: { value: e.filePath === 'NOFILE' ? '' : getLoadingBar(e.status, e.progress, e.filePath) },
            size: { value: nFormatter(e.fileSize) },
            job: { value: this.state.jobs.find(j => j.jobId === e.jobId)?.jobName },
            duration: { value: e.status === EXPORT_JOB_STATUS.FINISHED || e.status === EXPORT_JOB_STATUS.ERROR ? shortenHumanize((moment.utc(moment(e.updateDate).diff(moment(e.creationDate))).valueOf() || 0), { language: getCurrentLang()[0] }) : getDuration(e.creationDate) },
        })), 'updateDate', 'desc')
        const dataCurrentExports = toData(this.props.exportJobsTmp.filter(e => !e.scheduledOnJob))
        const dataScheduledExports = toData(this.props.exportJobsTmp.filter(e => e.scheduledOnJob))
        const groupedCities = keyBy(this.props.cities, 'code')
        const formattedPiezometers = this.props.piezometers.map(piezo => ({
            id: piezo.id,
            code: piezo.code,
            name: piezo.name,
            city: groupedCities[piezo.townCode]?.labelWithCode ?? '',
            townCode: piezo.townCode,
            labelSearch: searchAllCharacters(`${piezo.code}#${piezo.name}`),
        }))
        return (
            <div className='row no-margin padding-1'>
                <Card title={ i18n.export }>
                    <div className='card-content'>
                        <Grid2 container alignItems='center' spacing={1}>
                            <Grid2 size={2}>
                                <Select
                                    label={ i18n.exportName }
                                    options={ EXPORT_TYPE_OPTIONS }
                                    onChange={ v => this.setState({ exportType: v }) }
                                    value={ this.state.exportType }
                                />
                            </Grid2>
                            <Grid2 size={2} className='padding-top-1'>
                                <Checkbox
                                    label={ i18n.autoProg }
                                    checked={ this.state.scheduledOnJob }
                                    onChange={ v => this.setState({ scheduledOnJob: v }) }
                                />
                            </Grid2>
                            <Grid2 size={2}>
                                <Input
                                    title={ i18n.name }
                                    value={ this.state.name }
                                    onChange={ v => this.setState({ name: v }) }
                                    disabled={ !this.state.scheduledOnJob }
                                />
                            </Grid2>
                            <Grid2 size={3}>
                                <Select
                                    label={ i18n.job }
                                    options={ this.state.jobs }
                                    onChange={ v => this.setState({ jobId: v }) }
                                    value={ this.state.jobId }
                                    keyValue='jobId'
                                    keyLabel='jobName'
                                    disabled={ !this.state.scheduledOnJob }
                                />
                            </Grid2>
                            <Grid2 size={3} className='padding-top-1'>
                                <Checkbox
                                    label={ i18n.noZipExport }
                                    checked={ this.state.noZip }
                                    onChange={ v => this.setState({ noZip: v }) }
                                />
                            </Grid2>
                        </Grid2>
                        { this.getExportPanel() }

                        <SelectionTableModal
                            isOpen={ this.state.selectStationIsOpen }
                            onClose={ this.onCloseModal }
                            onValidate={ list => {
                                this.setState({ selectedStations: list, selectStationIsOpen: false })
                                this.onCloseModal()
                            } }
                            title={ i18n.listSumPesticidesSelection }

                            listData={ formattedPiezometers }
                            defaultSelectionList={ this.state.selectedStations }

                            listHeaders={ ['code', 'name', 'city'] }
                            listTitle={ i18n.nonSelectedStations }
                            selectionListTitle={ i18n.selectedStations }
                            maxHeightTable={ '53vh' }

                            filterField={ PiezometerFilterField }
                            filterFunction={ (list, filter) => {
                                const {
                                    filter: filterId = -1,
                                    resultFilter,
                                    searchValue,
                                    city,
                                } = filter

                                const filterCity = !isUndefined(city) ? list.filter(s => s.townCode === city) : list
                                const filterFilter = filterId !== -1 ? intersectionWith(filterCity, resultFilter, (elem, res) => elem.id === res.id) : filterCity
                                const searchValueFormat = searchAllCharacters(searchValue)
                                return searchValue ? filterFilter.filter(p => p.labelSearch.includes(searchValueFormat)) : filterFilter
                            } }
                        />
                    </div>
                </Card>
                <Table
                    title={ i18n.exportsInProgress }
                    data={ dataCurrentExports }
                    type={ { headers: ['status', 'fileLabel', 'duration', 'size', 'creationDate', 'updateDate', 'exportName', 'job', 'progression'] } }
                    color
                    sortable
                    paging
                    nbPerPageLabel={ nbPerPageLabelTiny }
                />
                <div className='padding-top-2'/>
                <Table
                    title={ i18n.exportsScheduled }
                    data={ dataScheduledExports }
                    type={ { headers: ['status', 'name', 'fileLabel', 'duration', 'size', 'creationDate', 'updateDate', 'exportName', 'job', 'progression'] } }
                    color
                    sortable
                    paging
                    nbPerPageLabel={ nbPerPageLabelTiny }
                    deletable onDelete={ e => setConfirmationModal(() => {
                        StationAction.deleteExportTmp(e.exportTmp)
                        this.regularProgressUpdate()
                    }) }
                />
            </div>
        )
    }
}

PiezometersExportApp.propTypes = ({
    piezometers: PropTypes.arrayOf(PropTypes.instanceOf(DtoPiezometerLight)),
    setTitle: PropTypes.func,
    fetchEnvironmentModelsByType: PropTypes.func,
    typeEnvironmentModels: PropTypes.arrayOf(PropTypes.string),
    exportModel: PropTypes.func,
    waitStart: PropTypes.func,
    waitStop: PropTypes.func,
    toastrWarning: PropTypes.func,
    fetchPiezometerChartLandmarks: PropTypes.func,
    piezometerChartLandmarks: PropTypes.arrayOf(PropTypes.instanceOf(DtoPiezometerChartLandmarks)),
    fetchPiezometryDataTypes: PropTypes.func,
    piezometryDataTypes: arrayOf(DtoParametrageDataType),
    exportJobsTmp: PropTypes.arrayOf(PropTypes.instanceOf(DtoExportJob)),
    fetchExportJobsTmp: PropTypes.func,
    runExportTmp: PropTypes.func,
    push: PropTypes.func,
    cities: PropTypes.arrayOf(PropTypes.instanceOf(CityDto)),
})

const mapStateToProps = store => ({
    piezometers: store.PiezometryReducer.piezometersLight,
    typeEnvironmentModels: store.ExportReducer.typeEnvironmentModels,
    piezometerChartLandmarks: store.PiezometryReducer.piezometerChartLandmarks,
    piezometryDataTypes: store.PiezometryReducer.piezometryDataTypes,
    exportJobsTmp: store.StationReducer.exportJobsTmp,
    cities: store.CityReducer.cities,
})

const mapDispatchToProps = {
    setTitle: HomeAction.setTitle,
    fetchEnvironmentModelsByType: ExportAction.fetchEnvironmentModelsByType,
    exportModel: ExportAction.exportModel,
    toastrWarning: ToastrAction.warning,
    fetchPiezometerChartLandmarks: PiezometryAction.fetchPiezometerChartLandmarks,
    waitStart: WaitAction.waitStart,
    waitStop: WaitAction.waitStop,
    fetchPiezometryDataTypes: PiezometryAction.fetchPiezometryDataTypes,
    fetchExportJobsTmp: StationAction.fetchExportJobsTmp,
    runExportTmp: ExportAction.runExportTmp,
    fetchPiezometersLight: PiezometryAction.fetchPiezometersLight,
    fetchCities: CityAction.fetchCities,
    push,
}

export default connect(mapStateToProps, mapDispatchToProps)(PiezometersExportApp)
